<template>
  <el-container class="study-layout">
    <el-header class="header-layout">
      <div class="study-header">
        <div class="header-logo">
          <img src="@/assets/images/logo.png" alt="" />
        </div>
        <div class="header-menu">
          <slot name="header"></slot>
        </div>
      </div>
    </el-header>
    <el-main class="content-layout">
      <slot></slot>
    </el-main>
    <public-footer />
  </el-container>
</template>

<script>
import PublicFooter from "@/components/Layouts/PublicFooter.vue";
export default {
  name: "StudyLayout",
  components: {
    PublicFooter,
  },
  props: {},
  data() {
    return {};
  },
  computed: {},
  mounted() {},
  updated() {},
  methods: {},
};
</script>

<style lang="scss" scoped>
.study-layout {
  background: transparent;
  min-width: 1042px;
  .header-layout {
    position: relative;
    z-index: 99;
    width: 100%;
    min-width: 1042px;
    height: 88px !important;
    padding: 0;
    background: url("~@/assets/images/head-banner.jpg") no-repeat;
    background-size: 100% 100%;
    box-shadow: 0 0 12px 0px rgba(0, 0, 0, 0.5);
  }
  .content-layout {
    width: 100%;
    background: url("~@/assets/images/body-bg.jpg") no-repeat;
    background-size: 100% 536px;
    padding: 0;
  }

  .study-header {
    width: 1002px;
    margin: 0 auto;
    height: 100%;
    display: flex;
  }
}

// 移动端响应式样式
@media (max-width: 1024px) {
  .study-layout {
    min-width: auto !important;
    width: 100% !important;
    max-width: 100% !important;
    overflow-x: hidden !important;

    .header-layout {
      min-width: auto !important;
      width: 100% !important;
      max-width: 100% !important;
      height: 70px !important;
      margin: 0 !important;
      padding: 0 !important;
      background-size: cover !important;
      background-position: center !important;
    }

    .content-layout {
      width: 100% !important;
      max-width: 100% !important;
      margin: 0 !important;
      padding: 0 !important;
      min-height: calc(100vh - 70px) !important;

      // 确保子组件能正常显示
      > * {
        width: 100% !important;
        max-width: 100% !important;
        min-width: auto !important;
        overflow-x: hidden !important;
      }
    }

    .study-header {
      width: 100% !important;
      max-width: 100% !important;
      min-width: auto !important;
      padding: 0 15px !important;
      margin: 0 !important;

      .header-logo {
        img {
          height: 40px !important;
          max-width: 100% !important;
        }
      }

      .header-menu {
        flex: 1;
        display: flex;
        justify-content: flex-end;
        align-items: center;

        .header-menu-item {
          color: white;
          font-size: 16px !important;
          padding: 8px 15px !important;
          cursor: pointer;
          border-radius: 4px;
          transition: all 0.3s ease;

          &:hover {
            background: rgba(255, 255, 255, 0.2);
          }

          &:active {
            transform: scale(0.95);
          }
        }
      }
    }
  }
}

// 小屏幕设备优化
@media (max-width: 768px) {
  .study-layout {
    .header-layout {
      height: 60px !important;
    }

    .content-layout {
      min-height: calc(100vh - 60px) !important;
    }

    .study-header {
      padding: 0 10px !important;

      .header-logo {
        img {
          height: 35px !important;
        }
      }

      .header-menu {
        .header-menu-item {
          font-size: 14px !important;
          padding: 6px 12px !important;
        }
      }
    }
  }
}

// 超小屏幕设备优化
@media (max-width: 480px) {
  .study-layout {
    .header-layout {
      height: 50px !important;
    }

    .content-layout {
      min-height: calc(100vh - 50px) !important;
    }

    .study-header {
      padding: 0 8px !important;

      .header-logo {
        img {
          height: 30px !important;
        }
      }

      .header-menu {
        .header-menu-item {
          font-size: 13px !important;
          padding: 5px 10px !important;
        }
      }
    }
  }
}

// 触摸设备优化
@media (hover: none) and (pointer: coarse) {
  .study-layout {
    .study-header {
      .header-menu {
        .header-menu-item {
          -webkit-tap-highlight-color: rgba(0, 0, 0, 0.1);
          min-height: 44px !important;
          min-width: 44px !important;
          display: flex !important;
          align-items: center !important;
          justify-content: center !important;
        }
      }
    }
  }
}

// 确保在所有设备上都没有水平滚动
@media (max-width: 1200px) {
}
</style>
